'use strict';
    // Declare app level module which depends on views, and components
angular.module('edApp', [
    'ngResource'
]).config(['$compileProvider', function ($compileProvider) {
    $compileProvider.debugInfoEnabled(false);
}]);